/**
 * Application router (T013).
 *
 * Uses `createBrowserRouter` with `React.lazy` + `Suspense` (fallback provided by AppLayout)
 * for per-route code splitting. Each page is its own chunk; react-router-dom itself is split
 * into a `router` manual chunk (vite.config.ts).
 */

import React from 'react';
import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import AppLayout from '../layout/AppLayout';
import { AuthGuard } from '../components/AuthGuard';

const Home = React.lazy(() => import('../pages/Home'));
const About = React.lazy(() => import('../pages/About'));
const Items = React.lazy(() => import('../pages/Items'));
const Dashboard = React.lazy(() => import('../pages/ServiceLivenessDashboard'));
const ApiRouteExplorer = React.lazy(() => import('../pages/ApiRouteExplorer'));
const Protected = React.lazy(() => import('../pages/Protected'));
const AuthTest = React.lazy(() => import('../pages/AuthTest'));
const NotFound = React.lazy(() => import('../pages/NotFound'));

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'about', element: <About /> },
      { path: 'items', element: <Items /> },
      {
        path: 'dashboard',
        element: (
          <AuthGuard>
            <Dashboard />
          </AuthGuard>
        ),
      },
      {
        path: 'api-explorer',
        element: (
          <AuthGuard>
            <ApiRouteExplorer />
          </AuthGuard>
        ),
      },
      {
        path: 'protected',
        element: (
          <AuthGuard>
            <Protected />
          </AuthGuard>
        ),
      },
      {
        path: 'auth-test',
        element: (
          <AuthGuard>
            <AuthTest />
          </AuthGuard>
        ),
      },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
